import AjaxStoreLazyLoadPlugin from '../../../Core/data/plugin/AjaxStoreLazyLoadPlugin.js';

export default class ResourceStoreLazyLoadPlugin extends AjaxStoreLazyLoadPlugin {
    static $name = 'ResourceStoreLazyLoadPlugin';

    internalUnloadRecord({ record }) {
        const
            me                     = this,
            { client }             = me,
            { eventStore }         = client,
            assignments            = [...record.assignments],
            unloadedAssignments    = me.$unloadedAssignments ?? (me.$unloadedAssignments = []),
            removeUnassignedEvents = !eventStore.usesSingleAssignment && eventStore.removeUnassignedEvent;

        // Engine does not support assignments without a resource,
        // so we cache assignments for unloaded resources
        unloadedAssignments.push(...assignments);

        if (removeUnassignedEvents) {
            eventStore.removeUnassignedEvent = false;
        }

        super.internalUnloadRecord({ record });
        me.pauseStm();
        client.afterResourceRemoval();
        me.resumeStm();

        if (removeUnassignedEvents) {
            eventStore.removeUnassignedEvent = true;
        }

        // Clear change tracking
        client.assignmentStore.removed.remove(assignments);

        // So that engine will set new connections later
        unloadedAssignments.forEach(a => {
            a.resource = a.resourceId;
            a.event = a.eventId;
        });
    }

    addData(resourcesData) {
        const
            { $unloadedAssignments, client } = this;
        let refresh = false;

        super.addData(...arguments);

        // check if there are any cached assignments to bring back to the store
        if ($unloadedAssignments?.length) {
            const assignmentsToAdd = $unloadedAssignments.filter(a => resourcesData.some(r => r.id === a.resourceId));

            if (assignmentsToAdd.length) {
                this.pauseStm();
                client.assignmentStore.add(assignmentsToAdd);
                this.resumeStm();
                refresh = true;
            }
        }
        refresh && client.trigger('refresh', { action : 'lazyload' });
    }
}
